import { useEffect, useState, useContext } from 'react';

import { AppContext } from '../../store/appContext';
import { ContainerResponse } from '../../store/types';
import { useService } from '../../store/useService';
import { isZhyRegion } from '../Utils/Utils';
import { CONTAINER_SUGGESTIONS } from './ScanContainerService';

export const useContainerSuggestions = (mpn?: string, site?: string, canCall?: boolean) => {
  const appContext = useContext(AppContext);
  const zhyRegion = isZhyRegion(appContext.appType);
  const { useLazyQuery } = useService();

  const [containerSuggestions, setContainerSuggestions] = useState<ContainerResponse[]>([]);
  const [getContainerSuggestions, { loading, called }] = useLazyQuery(CONTAINER_SUGGESTIONS, {
    fetchPolicy: 'cache-first',
    onCompleted: (data) => {
      setContainerSuggestions(data?.getContainerSuggestions?.containers);
    },
    onError: () => {
      setContainerSuggestions([]);
    },
  });

  useEffect(() => {
    if (called || !mpn || !site || !canCall || mpn?.trim()?.length === 0 || site?.trim()?.length === 0 || zhyRegion) {
      return;
    }

    // Assume first 3 characters are the airport code and remove any leading 0s from the site number
    const unpaddedSiteCode = site.substring(0, 3) + site.substring(3).replace(/^0+/, '');

    getContainerSuggestions({
      variables: {
        mpn: mpn,
        site: unpaddedSiteCode,
      },
    });
  }, [mpn, site, called, canCall, getContainerSuggestions, zhyRegion]);

  return {
    containerSuggestions,
    loading: loading && canCall && !zhyRegion,
    getContainerSuggestions,
  };
};

export default useContainerSuggestions;
